/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function BellSolid({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <g clipPath="url(#clip0_1331_40987)">
                <path d="M16.111 11.5862V9.69145C16.1118 8.41087 15.6241 7.1675 14.7267 6.16237C13.8293 5.15725 12.5747 4.44915 11.1658 4.15258C11.1765 4.11584 11.1849 4.07859 11.1908 4.041V1.55262C11.1908 1.27345 11.0654 1.00571 10.8421 0.808304C10.6189 0.610901 10.3161 0.5 10.0003 0.5C9.68459 0.5 9.38179 0.610901 9.15853 0.808304C8.93527 1.00571 8.80985 1.27345 8.80985 1.55262V4.041C8.81577 4.07859 8.82412 4.11584 8.83485 4.15258C7.42593 4.44915 6.17134 5.15725 5.27395 6.16237C4.37655 7.1675 3.88881 8.41087 3.88961 9.69145V11.5862C3.88961 14.0977 1.66699 14.7251 1.66699 15.9808C1.66699 16.605 1.66699 17.2366 2.30747 17.2366H17.6932C18.3337 17.2366 18.3337 16.605 18.3337 15.9808C18.3337 14.7251 16.111 14.0977 16.111 11.5862Z" fill="currentColor" />
                <path d="M6.21818 18.2892C6.53399 18.945 7.06091 19.5043 7.73338 19.8973C8.40585 20.2904 9.19419 20.5 10.0003 20.5C10.8065 20.5 11.5948 20.2904 12.2673 19.8973C12.9397 19.5043 13.4667 18.945 13.7825 18.2892H6.21818Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_1331_40987">
                    <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
